import { render, staticRenderFns } from "./ImgDetails.vue?vue&type=template&id=09999815&scoped=true&slot-scope=scope&"
import script from "./ImgDetails.vue?vue&type=script&lang=js&"
export * from "./ImgDetails.vue?vue&type=script&lang=js&"
import style0 from "./ImgDetails.vue?vue&type=style&index=0&id=09999815&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09999815",
  null
  
)

export default component.exports